import * as CONSTANTS from './constants'

/* eslint-disable import/prefer-default-export */
export const accessRejected = meta => ({
  error: true,
  meta,
  payload: {},
  type: CONSTANTS.ACCESS_REJECTED
})
